export const isMobileBrowser = (): boolean => {
  const mobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const smallScreen = window.innerWidth <= 768
  const touchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0

  return mobileUA || (smallScreen && touchDevice)
}
